<script>
export default {
  name: 'Logout',
  beforeMount() {
    this.$http.post('/auth/logout');
    this.$store.commit('unsetUser');
    this.$store.commit('unsetTfa');
    this.$router.push({ name: 'Login' });
  }
};
</script>

<template>
  <div />
</template>
